export default __webpack_public_path__ + "static/applet-22-set-1-505f598f8f4f7260185057fa563cfa07.webp";